import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManualOfficeSettlement extends Layout {
    buttonClear: Button;
    buttonJobClassification: Button;
    checkboxCreateCheckRecord: Checkbox;
    checkboxCreateGlEntries: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelDetails: Label;
    labelEmployerLiabilities: Label;
    labelHours: Label;
    labelJobClassifcation: Label;
    labelPayRates: Label;
    labelTotals: Label;
    labelWages: Label;
    labelWithholdings: Label;
    panel401kTotals: Panel;
    panelCityWages: Panel;
    panelCityWithholding: Panel;
    panelCountyWages: Panel;
    panelCountyWithholding: Panel;
    panelEmployerFuta: Panel;
    panelEmployerFutaSpacer: Panel;
    panelEmployerLiabilities: Panel;
    panelEmployerLiabilityAmounts: Panel;
    panelEmployerLiabilitySpacer2: Panel;
    panelEmployerLiabilitySpacer: Panel;
    panelEmployerMedicare: Panel;
    panelEmployerSdi: Panel;
    panelEmployerSdiSpacer: Panel;
    panelEmployerSocialSecurity: Panel;
    panelEmployerSui: Panel;
    panelEmployerSuiSpacer: Panel;
    panelFederalWages: Panel;
    panelFederalWithholding: Panel;
    panelGeneral: Panel;
    panelGrossWages: Panel;
    panelHours: Panel;
    panelJobClassification: Panel;
    panelMedicareWages: Panel;
    panelMedicareWithholding: Panel;
    panelNonTaxableWages: Panel;
    panelPayAdjustmentTotals: Panel;
    panelPayRates: Panel;
    panelSocialSecurityWages: Panel;
    panelSocialSecurityWithholding: Panel;
    panelStateWages: Panel;
    panelStateWithholding: Panel;
    panelTimecardDetails: Panel;
    panelTimecardTotals: Panel;
    panelTotals: Panel;
    panelWages: Panel;
    panelWagesFields: Panel;
    panelWithholdingAmounts: Panel;
    panelWithholdingSpacer: Panel;
    panelWithholdings: Panel;
    sourceOffMan401k: DataSource;
    sourceOffManDeduct: DataSource;
    sourceOffManSettlement: DataSource;
    tab401kDetails: Tab;
    tabCheckInformation: Tab;
    tabPayAdjustments: Tab;
    tabTimecard: Tab;
    table401kDetails: Table;
    tablePayAdjustments: Table;
    tabsetManualSettlement: Tabset;
    textboxAdditionalTaxOverrideHours: Textbox;
    textboxCalculatedAmount: Textbox;
    textboxCheckAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxCityTaxId: Textbox;
    textboxCityWages: Textbox;
    textboxCityWithholding: Textbox;
    textboxCountyTaxId: Textbox;
    textboxCountyWages: Textbox;
    textboxCountyWithholding: Textbox;
    textboxDetailLines: Textbox;
    textboxDivision: Textbox;
    textboxEmployerEtt: Textbox;
    textboxEmployerFuta: Textbox;
    textboxEmployerMedicare: Textbox;
    textboxEmployerSdi: Textbox;
    textboxEmployerSocialSecurity: Textbox;
    textboxEmployerSui: Textbox;
    textboxEttWages: Textbox;
    textboxFederalWages: Textbox;
    textboxFederalWithholding: Textbox;
    textboxFrequency: Textbox;
    textboxFutaWages: Textbox;
    textboxGrossWages: Textbox;
    textboxHolidayHours: Textbox;
    textboxHolidayRate: Textbox;
    textboxHolidayTotal: Textbox;
    textboxJobClass: Textbox;
    textboxMedicareWages: Textbox;
    textboxMedicareWithholding: Textbox;
    textboxNonTaxableWages: Textbox;
    textboxOffManTimecarddepartment: Textbox;
    textboxOffManTimecardpayperiodEnd: Textbox;
    textboxOffManTimecardpayperiodStart: Textbox;
    textboxOffManTimecardtotalHours: Textbox;
    textboxOffManTimecardtotalPay: Textbox;
    textboxOldBalApplied: Textbox;
    textboxOvertimeHours: Textbox;
    textboxOvertimeRate: Textbox;
    textboxOvertimeTotal: Textbox;
    textboxPayMethod: Textbox;
    textboxPayee: Textbox;
    textboxPfmlWages: Textbox;
    textboxRecordType: Textbox;
    textboxRegularHours: Textbox;
    textboxRegularRate: Textbox;
    textboxRegularTotal: Textbox;
    textboxSdiWages: Textbox;
    textboxSdiWithholding: Textbox;
    textboxSickHours: Textbox;
    textboxSickRate: Textbox;
    textboxSickTotal: Textbox;
    textboxSocialSecurityWages: Textbox;
    textboxSocialSecurityWithholding: Textbox;
    textboxStateTaxId: Textbox;
    textboxStateWages: Textbox;
    textboxStateWithholding: Textbox;
    textboxSuiTaxCode: Textbox;
    textboxSuiWages: Textbox;
    textboxSuiWagesWithoutCutoff: Textbox;
    textboxSuiWithholding: Textbox;
    textboxTerminal: Textbox;
    textboxTotalEarnings: Textbox;
    textboxTotalEmployerMatch: Textbox;
    textboxTotalPayAdjustmentsReimbursements: Textbox;
    textboxTotalPayeeContribution: Textbox;
    textboxVacationHours: Textbox;
    textboxVacationRate: Textbox;
    textboxVacationTotal: Textbox;
}
